import React, {useRef} from 'react';
import cn from 'classnames';

import ProductBadges from 'brandComponents/product/ProductBadges';
import ProductImages from 'brandComponents/ProductImages';
import {ViewType} from 'brandConstants';

import {ImagesCarousel} from './Subcomponents/ImagesCarousel';
import {IProductDetailImagesProps} from './IProductDetailImages';

import styles from './ProductDetailImages.module.scss';

const PDP_MAIN_VIEWTYPE = ViewType.ZOOM;

const ProductDetailImages = ({product}: IProductDetailImagesProps) => {
	const wrapperRef = useRef(null);
	const badgesIds = product.getBadgesIds();

	return (
		<section
			className={cn(styles['product-detail-images'], {
				[styles['new-arrival']]: product.isNewArrival()
			})}
			ref={wrapperRef}
		>
			<ProductImages product={product} viewType={PDP_MAIN_VIEWTYPE} parentRef={wrapperRef?.current} />
			<ImagesCarousel product={product} />
			{!!badgesIds && (
				<ProductBadges
					showOnlyFillVariants
					className={styles['product-detail-images__badges']}
					badgesList={badgesIds}
				/>
			)}
		</section>
	);
};

export default ProductDetailImages;
